import { Helmet } from "react-helmet";
import type React from "react";
import { useCallback, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { closeModal } from "store";
import { useDispatch } from "react-redux";
import { useDeviceType } from "hooks";
import { DetailPage13 } from "components/sections/section-13/detailPage/DetailPage";
import { NewArticle } from "components/sections/section-13/detailPage/article/new-article/new-article";
import { EditArticle } from "components/sections/section-13/detailPage/article/edit-article/edit-article";
import { AdminArticle } from "components/sections/section-13/detailPage/article/admin-article/admin-article";
import { Section13 } from "components/sections/section-13";

interface DetailPageProps {
  handleClose: (sectionId: string, sectionNumber: number) => void;
}

const customPathToDetailIdMap: Record<string, React.FC<DetailPageProps>> = {
  blog: Section13,
  article: DetailPage13,
  "admin-article": AdminArticle,
  "new-article": NewArticle,
  "edit-article": EditArticle,
};

const DetailPageContainer = () => {
  const customPath = useParams<{ customPath?: string }>().customPath ?? "";
  const { pathname } = useLocation();

  const [translate, setTranslate] = useState(0);
  const [activeSection, setActiveSection] = useState<number>(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { device } = useDeviceType();

  const handleClose = useCallback(
    (sectionId: string, sectionNumber: number) => {
      dispatch(closeModal());

      setActiveSection(sectionNumber);

      if (device === "mobile") {
        setTranslate(sectionNumber * window.innerHeight);
      }

      navigate("/", {
        replace: true,
        state: { activeId: sectionId, activeSectionNumber: sectionNumber },
      });
    },
    [navigate, dispatch, device]
  );

  const PageComponent = pathname.includes("/article/")
    ? DetailPage13
    : customPathToDetailIdMap[customPath];

  if (!PageComponent) {
    return <h1>Page Not Found</h1>;
  }

  return (
    <>
      <Helmet>
        <title>MindScriber</title>
        <meta name="description" content="MindScriber blog and articles." />
        <link rel="canonical" href={`https://mindscriber.com/${customPath}`} />
      </Helmet>

      <PageComponent handleClose={handleClose} />
    </>
  );
};

export default DetailPageContainer;
